import type { ICircuitModel, IStructureCircuitModel } from '@/interfaces/models';
import { StructureCircuitModel } from '@/models/StructureCircuitModel';

export class StructureCircuitModelFactory {
  create(circuitModel: ICircuitModel): IStructureCircuitModel {
    return new StructureCircuitModel(circuitModel);
  }
}
